import React, {Component} from 'react';

import {Table, Card, Row, Col, Form, Image} from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import PatientPaymentView from '../PatientPayment/PatientPaymentView';
import PatientPaymentStatusChange from '../PatientPayment/PatientPaymentStatusChange';

import '../../Common/Common.css';
var dateFormat = require('dateformat');

class PatientPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PatientPaymentShow: false,
      showPatientPaymentActive: false,
      page: 0,
      perPage: 10,
      searchPatientPayment: '',
      filterValue: '',
    };
  }

  componentDidMount() {
    this.props.patientPaymentList({
      page: undefined,
      search: this.state.searchPatientPayment,
      filter: this.state.filterValue,
    });
  }

  handlePatientPaymentView = item => {
    this.setState({
      PatientPaymentShow: true,
      PatientPaymentDtls: item,
    });
  };

  handleClosePatientPaymentView = () => {
    this.setState({PatientPaymentShow: false});
  };

  handlePageClick = e => {
    const selectedPage = e.selected;
    this.props.PatientpaySlectedPage({
      page: selectedPage + 1,
      search: this.state.searchPatientPayment,
      filter: this.state.filterValue,
    });
    this.setState({page: selectedPage});
  };
  resetPage = () => {
    this.setState({page: 0});
  };

  handlePatientPaymentActiveView = item => {
    this.setState({
      showPatientPaymentActive: true,
      PatientPaymentActiveDtls: item,
    });
  };
  handleCloseActive = () => {
    this.setState({showPatientPaymentActive: false});
  };

  SearchOnChange = event => {
    this.setState(
      {
        searchPatientPayment: event.target.value,
        page: 0,
      },
      () => {
        this.props.patientPaymentList({
          page: undefined,
          search: this.state.searchPatientPayment,
          filter: this.state.filterValue,
        });
      }
    );
  };

  handleChange = event => {
    this.setState(
      {
        filterValue: event.target.value,
        page: 0,
      },
      () => {
        this.props.patientPaymentList({
          page: undefined,
          search: this.state.searchPatientPayment,
          filter: this.state.filterValue,
        });
      }
    );
  };

  render() {
    let p = this.state.page + 1;
    const count =
      this.props.patientPaymentDtlsCount && this.props.patientPaymentDtlsCount;
    let PatientPaymentPageCount = Math.ceil(count / this.state.perPage);

    return (
      <div>
        <Card>
          <Card.Header>
               <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>Patient Payments</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={this.state.filterValue}
                    onChange={this.handleChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    <option value="open">Open</option>
                    {/* <option value="partial">Partial</option> */}
                    <option value="paid">Paid</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon" />
                    <input
                      type="text"
                      placeholder="Reference No/Order ID"
                      onChange={this.SearchOnChange}
                      value={this.state.searchPatientPayment}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon" />
                  <span className="cmnPageCount">
                    {count === undefined ? 0 : count}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Table responsive bordered striped className="cmnMainTable">
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>REFERENCE NO</th>
                    <th>ORDER ID</th>
                    <th>CHEMIST</th>
                    <th>CUSTOMER NAME</th>
                    <th>CREATED DATE</th>
                    <th>AMOUNT</th>
                    <th>STATUS</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.patientPaymentDtlsList &&
                    this.props.patientPaymentDtlsList.map((item, i) =>
                      <tr key={i}>
                        <td className="cmn_Cap">
                          {10 * (p - 1) + i + 1}
                        </td>
                        <td className="">
                          {item && item.invNo}
                        </td>
                        <td className="cmn_Cap ">
                          {item && item.orderId && item.orderId.orderNo}
                        </td>
                        <td className="cmn_Cap">
                          {item && item.recptDtls && item.recptDtls.name}
                        </td>
                        <td className="cmn_Cap">
                          {item && item.orderId && item.orderId.orderFromName}
                        </td>
                        <td className="cmn_Cap ">
                          {dateFormat(item && item.createdAt, 'mediumDate')}
                        </td>
                        <td className="rightAlign">
                          {item && item.paidAmnt}
                        </td>
                        <td className="cmn_Cap ">
                          {item && item.status}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.handlePatientPaymentView({item: item})}
                            />

                            <i
                              className="fa fa-ban fa-lg"
                              style={{paddingLeft: 10}}
                              onClick={() =>
                                this.handlePatientPaymentActiveView({
                                  item: item,
                                })}
                            />
                            <PatientPaymentStatusChange
                              show={this.state.showPatientPaymentActive}
                              handleClose={this.handleCloseActive}
                              PatientPaymentActiveDtls={
                                this.state.PatientPaymentActiveDtls
                              }
                              refreshParams={{
                                page: 1,
                                search: this.state.searchPatientPayment,
                                filter: this.state.filterValue,
                              }}
                              PatientPaymentStatusChange={
                                this.props.PatientPaymentStatusChange
                              }
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    )}
                </tbody>
              </Table>
              <PatientPaymentView
                show={this.state.PatientPaymentShow}
                handleClose={this.handleClosePatientPaymentView}
                PatientPaymentDtls={this.state.PatientPaymentDtls}
                refreshParams={{
                  page: 1,
                  search: this.state.searchPatientPayment,
                  filter: this.state.filterValue,
                }}
                PatientRefundStatusChange={this.props.PatientRefundStatusChange}
              />

              {(this.props.patientPaymentDtlsList === undefined ||
                (this.props.patientPaymentDtlsList &&
                  this.props.patientPaymentDtlsList.length === 0)) &&
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require('../../../../src/assets/img/nodata4.png')}
                    />
                  </div>
                  <div className="noDataTextDiv">No Payments Found</div>
                </div>}
            </div>
          </Card.Body>

          {PatientPaymentPageCount > 1
            ? <div className="paginationDiv">
                <ReactPaginate
                  forcePage={this.state.page}
                  previousLabel={'Prev'}
                  nextLabel={'Next'}
                  breakLabel={'...'}
                  breakClassName={'break-me'}
                  pageCount={PatientPaymentPageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={'pagination flex-wrap'}
                  subContainerClassName={'pages pagination'}
                  activeClassName={'active'}
                />
              </div>
            : null}
        </Card>
      </div>
    );
  }
}
export default PatientPayment;
